define('bindingHandlers/validation/controlMessage',[
    'jquery',
    'lib/knockout'
], function ($, ko) {
    'use strict';

    /**
     * A binding handler for displaying validation information.
     *
     * Usage Examples:
     *
     * - Pass in the validation observable directly (default and most common behaviour):
     *      <span class="help-block" data-bind="controlMessage: edgeGroup"></span>
     *
     * - Pass in data as an object:
     *       <span class="help-block" data-bind="controlMessage: {
     *                   value: edgeGroup,
     *                   renderAsHtml: true} "></span>
     *      options:
     *          value (required) - The validation observable.
     *          renderAsHtml (optional) - When true, uses HTML in the control message instead of just text.
     */
    ko.bindingHandlers.controlMessage = {
        init: function (element) {
            // Previous implementations used $(element).hide() and $(element).toggle()
            // to hide/show, but we had problems with safari slowly calculating styles
            // on complex forms with tons of control-messages.
            // TA-2095
            $(element).addClass('control-message');
            element.style.display = 'none';

            // You'll get double binding errors if renderAsHtml is true and the observable is initially in error without this.
            return { controlsDescendantBindings: true };
        },
        update: function(element, valueAccessor, allBindings, viewModel, bindingContext) {
            var options = valueAccessor();
            var observable;
            var renderAsHtml = false;
            if (typeof options === 'object') {
                observable = options.value;
                renderAsHtml = options.renderAsHtml;
            }
            else {
                observable = options;
            }

            if (observable.isModified && observable.isValid && observable.error) {
                if (renderAsHtml) {
                    $(element).html(observable.error()); // Update error message text allowing HTML content.
                    ko.applyBindingsToDescendants(bindingContext, element);
                }
                else {
                    $(element).text(observable.error()); // Update error message with raw text.
                }

                var needToShow = observable.isModified() && !observable.isValid();
                element.style.display = needToShow ? '' : 'none'; // Set error message visibility.
            }
        }
    };
});

